import React, { useRef } from "react";
import { useMutation } from "@apollo/client/react";
import { faFlag, faTimesCircle } from "@fortawesome/pro-solid-svg-icons";

import { Button } from "@/components";
import { TextInput } from "@/components/forms";
import { useModal } from "@/hooks/use-modal";

import { MUTATE_REPORT_ANIMATION } from "../../../gql/queries/mutate-report-animation";
import { ButtonBar, Module } from "../../layouts";
import { ButtonGroup } from "../../layouts/button-group";

import ModalTitle from "./modal-title";
import ReportFailedModal from "./report-failed";
import ReportSubmittedModal from "./report-submitted";

type ReportModalProps = {
  id: number;
};

const ReportModal = (props: ReportModalProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { openModal, closeModal } = useModal();
  const [mutateReportAnimaton] = useMutation(MUTATE_REPORT_ANIMATION, {
    onCompleted: () => {
      openModal(() => <ReportSubmittedModal />);
    },
    onError: () => {
      openModal(() => <ReportFailedModal />);
    },
  });

  const onCancelClicked = () => {
    closeModal();
  };

  const onReportClicked = () => {
    mutateReportAnimaton({
      variables: {
        id: props.id,
        reason: inputRef?.current?.value ?? "",
      },
    });
    closeModal();
  };

  return (
    <div>
      <ModalTitle>Report Inappropriate Animation</ModalTitle>
      <Module>
        <p>Animations should be suitable for all ages.</p>
        <p>Some things considered inappropriate include:</p>
        <ul className="list-disc list-inside">
          <li>Swearing or offensive language</li>
          <li>Naked body parts</li>
        </ul>
      </Module>
      <Module>
        <p>
          If you think this animation is not appropriate, you can report it
          here. You can optionally submit a reason why you think it is not
          appropriate.
        </p>
      </Module>
      <Module>
        <TextInput
          id="reportReason"
          type="text"
          name="report-reason"
          label="Report reason:"
          ref={inputRef}
        />
      </Module>
      <ButtonBar>
        <ButtonGroup align="right">
          <Button
            icon={faTimesCircle}
            onClick={onCancelClicked}
            type="negative"
          >
            Cancel
          </Button>
          <Button icon={faFlag} onClick={onReportClicked} type="positive">
            Submit report
          </Button>
        </ButtonGroup>
      </ButtonBar>
    </div>
  );
};

export default ReportModal;
